import captureException from './captureException';
export function getSessionStorageItem(key) {
  try {
    const value = sessionStorage.getItem(key);
    if (!value) return null;
    return JSON.parse(value);
  } catch (err) {
    captureException(err);
    return null;
  }
}
export function setSessionStorageItem(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    captureException(err);
  }
}
export function removeSessionStorageItem(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    captureException(err);
  }
}